exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5[data-v-735746bb]{padding:5px;background:#eceef6}.borcmodalbuton2[data-v-735746bb]{position:absolute;top:15px;right:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-735746bb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Esayac/Comp/EsayacDonem.vue
// module id = 1042
// module chunks = 0